module.exports = __webpack_public_path__ + "it_CH-header-5ae34b.webp";